import { http } from '@/providers/apis/http';
import { competencySerializer } from '@/providers/serializers/competency/competency';
import { DomainModel } from '@/models/proficiency/domain';
import { FacetMatrix } from '@/models/proficiency/facet-matrix';

export class CompetencyAPI {

  private static INSTANCE = new CompetencyAPI();

  private namespace = 'api/ds/users';

  private missionControlNamespace = 'api/missioncontrol/v1';

  private missionControlNamespaceV2 = 'api/missioncontrol/v2';

  private adminControlNamespace = 'api/v1/admin-utils';

  private adminNamespace = 'api/admin/v1';

  static get instance() {
    return this.INSTANCE;
  }

  public fetchUserDomainCompetencyMatrix(params: any): Promise<DomainModel[]> {
    const endpoint = `${this.namespace}/v2/tx/competency/matrix/domain`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeDomainCompetencyMatrix(response.data);
    });
  }

  public getCompetencyMatrixCoordinates(params: any): Promise<DomainModel[]> {
    const endpoint = `${this.namespace}/v2/tx/competency/matrix/coordinates`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeMatrixCoOrdinates(response.data);
    });
  }

  public fetchAllFacetsCompetencyMatrix<T>(params: any): Promise<FacetMatrix[]> {
    const endpoint = `${this.namespace}/v2/tx/subjects/competency/matrix`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeFacetsCompetencyMatrix(response.data);
    });
  }

  public fetchDomainTopicCompetencyMatrix(params: any) {
    const endpoint = `${this.missionControlNamespace}/tx/competency/matrix/domain/topics`;
    // const endpoint = `${window.location.origin}/stubs/dtc.json`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeDomainTopicMatrix(response.data);
    });
  }

  public fetchSubjectDomainTopicMetadata(params: any) {
    const endpoint = `${this.missionControlNamespaceV2}/tx/subject/domain/topics`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return competencySerializer.serializeDomainTopicMetadata(response.data);
    });
  }

  public updateTaxonomy(params: any, fwdCode: any, subjectCode: any, compCode: any) {
    const endpoint = `${this.adminControlNamespace}/taxonomy/fw_code/${fwdCode}/subject_code/${subjectCode}/comp_code/${compCode}`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, params).then((response) => {
      return response.data;
    })
    .catch((error: any) => {
      return error.response.data;
    });
  }
  public getGdotList(params: any) {
    const endpoint = `${this.adminNamespace}/ucm`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return response.data;
    })
    .catch((error: any) => {
      return error.response.data;
    });
  }
  public getUniversalSubjectList(searchTerm = '') {
    let param;
    if (searchTerm) {
      param = {
        universal_subject_name: searchTerm,
      };
    }
    const endpoint = `${this.adminNamespace}/ucc/subject/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, param).then((response) => {
      return response.data;
    })
    .catch((error: any) => {
      return error.response.data;
    });
  }
  public createUniversalSubject(params: any) {
    const endpoint = `${this.adminNamespace}/ucm/create`;
    const headers = http.getTokenHeaders();
    return http.post(endpoint, headers, params).then((response) => {
        return response;
    }).catch((error: any) => {
        return  error.response;
    });
  }
  public getRequestList(requestId: any) {
    const endpoint = `${this.adminNamespace}/ucm/request/data/${requestId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    })
    .catch((error: any) => {
      return error.response.data;
    });
  }
  public publishRequest(requestId: any) {
    const endpoint = `${this.adminNamespace}/ucm/publish/request/${requestId}`;
    const params = {};
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, params).then((response) => {
      return response.data;
    })
    .catch((error: any) => {
      return error.response.data;
    });
  }
  public saveDraft(params: any) {
    const endpoint = `${this.adminNamespace}/ucm/request/data`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, params).then((response) => {
      return response.data;
    })
    .catch((error: any) => {
      return error.response.data;
    });
  }
  public checkMapping(params: any) {
    const endpoint = `${this.adminNamespace}/ucc/check`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, params).then((response) => {
      return response;
    })
    .catch((error: any) => {
      return error.response;
    });
  }
}

export const competencyAPI = CompetencyAPI.instance;
